module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_1.f7805832.png";